import type {Theme} from '@material-ui/core/styles';
import {createStyles} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexGrow: 1,
    },
    main: {
        height: '100%',
    },
    errorTitle: {
        fontSize: '150px',
        lineHeight: 1.2,
        fontWeight: 900,
        position: 'relative',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.error.dark,
        borderRadius: '8px',
        textAlign: 'center',
        textShadow:
            'rgb(255 23 58 / 30%) 5px 1px, rgb(255 23 58 / 20%) 10px 3px',
    },
    errorSubTitle: {
        fontSize: '32px',
        fontWeight: 300,
        color: theme.palette.text.secondary,
    },
}));
